import {checkCookie} from '../utils/cookies';

export default function submitUserInfoToEtracker() {
    if (!window.et_eC_Wrapper) {
        return;
    }

    window.et_eC_Wrapper({et_et: '4aKeFx', et_seg2: checkCookie('juve_login_session') ? 'ja' : 'nein'});
}
